module.exports = __webpack_public_path__ + "img/infoguidance_mov_05.a8397584.jpg";